// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-YWX_","col":"styles_col__1ou7Z"};